module.exports = __webpack_public_path__ + "static/media/scoli-adams-2f.bfa35d19.png";